import React from "react";
import { Link } from "react-router-dom";

const BreadCrumb = () => {
  const hash = window.location.hash;
  const path = hash.substring(2).split("?")[0]; // Remove the initial #/ and discard URL parameters
  const segments = path.split("/").filter((segment) => segment); // Split and filter out empty segments

  const capitalize = (str) => {
    return str
      .replace(/-/g, " ")
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };

  return (
    <nav
      aria-label="breadcrumb"
      style={{
        margin: "0",
        fontFamily: "inter",
        height: "32px",
        display: "flex",
        alignItems: "center",
      }}
    >
      <div
        type="none"
        className="breadcrumb"
        style={{ display: "flex", flexWrap: "nowrap" }}
      >
        {segments.map((segment, index) => {
          const url = `/${segments.slice(0, index + 1).join("/")}`; // Remove the hash to build the correct URL
          return (
            <div
              key={index}
              className="breadcrumb-item"
              style={{
                marginRight: "5px",
                color: "#344450",
                fontWeight: "500",
              }}
            >
              {index < segments.length - 1 ? (
                <>
                  <Link
                    to={url}
                    style={{
                      textDecoration: "none",
                      color: "#47667d",
                      fontWeight: "500",
                    }}
                  >
                    {capitalize(segment)}{" "}
                  </Link>
                  <span
                    style={{
                      margin: "0 3px 0 0",
                      color: "#344450",
                      fontWeight: "500",
                      // fontSize: "18px",
                    }}
                  >
                    /
                  </span>
                </>
              ) : (
                capitalize(segment)
              )}
            </div>
          );
        })}
      </div>
    </nav>
  );
};

export default BreadCrumb;
// import React from "react";
// import { Link, useLocation } from "react-router-dom";

// const BreadCrumb = () => {
//   const location = useLocation();
//   const hash = window.location.hash;
//   const path = hash.substring(2).split("?")[0];
//   const segments = path.split("/").filter((segment) => segment);

//   const from = location.state?.from; // can be "Reports" or "Tickets"

//   const capitalize = (str) => {
//     return str
//       .replace(/-/g, " ")
//       .replace(/\b\w/g, (char) => char.toUpperCase());
//   };

//   // Override segments if you're on ticket detail page
//   const isTicketDetail = segments.includes("Details-of-Ticket");

//   let finalSegments = [...segments];
//   if (isTicketDetail && from) {
//     finalSegments = [from.toLowerCase(), "Details-of-Ticket"];
//   }

//   return (
//     <nav
//       aria-label="breadcrumb"
//       style={{
//         margin: "0",
//         fontFamily: "inter",
//         height: "32px",
//         display: "flex",
//         alignItems: "center",
//       }}
//     >
//       <div
//         className="breadcrumb"
//         style={{ display: "flex", flexWrap: "nowrap" }}
//       >
//         {finalSegments.map((segment, index) => {
//           const url = `/${finalSegments.slice(0, index + 1).join("/")}`;

//           return (
//             <div
//               key={index}
//               className="breadcrumb-item"
//               style={{
//                 marginRight: "5px",
//                 color: "#344450",
//                 fontWeight: "500",
//               }}
//             >
//               {index < finalSegments.length - 1 ? (
//                 <>
//                   <Link
//                     to={url}
//                     style={{
//                       textDecoration: "none",
//                       color: "#2575D0",
//                       fontWeight: "500",
//                     }}
//                     state={{ from }} // Maintain state on back navigation
//                   >
//                     {capitalize(segment)}
//                   </Link>
//                   <span
//                     style={{
//                       margin: "0 3px 0 0",
//                       color: "#2575D0",
//                       fontWeight: "500",
//                       fontSize: "14px",
//                     }}
//                   >
//                     /
//                   </span>
//                 </>
//               ) : (
//                 capitalize(segment)
//               )}
//             </div>
//           );
//         })}
//       </div>
//     </nav>
//   );
// };

// export default BreadCrumb;
